export enum ContactPageIdeasTabSectionId {
  FAVORITES = 'favorites',
  THOUGHTS = 'thoughts',
  WISH_LIST = 'wish-list',
}
